import {
  BarberSharedForm,
  ShopSharedForm,
  BrandSharedForm,
} from '../SharedForm';
import enhance from './AddProductContainer';

export const BarberAddProduct = enhance(BarberSharedForm);
export const ShopAddProduct = enhance(ShopSharedForm);
export const BrandAddProduct = enhance(BrandSharedForm);
